export type Brand = 'neuroiq' | 'default';

export function useBrand(): Brand {
  return window.location.hostname.startsWith('neuroiq') ? 'neuroiq' : 'default';
}
